module.exports = __webpack_public_path__ + "media/assets/images/number-plate-yellow-79ade805c5e87af1bf93e50564a0eb05.png";